module.exports = __webpack_public_path__ + "static/media/register-picture.04cc62d6.png";